import { useCallback } from 'react';
import {
  connectPrinter,
  disconnectPrinter,
  isConnectedCheck,
} from 'shared/printerManager';

export const usePrintManager = () => {
  const STATUS_CONNECTED = 'Connected';

  const isConnected = useCallback(() => {
    return isConnectedCheck();
  }, []);

  const connect = useCallback(
    async (ipAddress, setConnectionStatus, setIsVisible) => {
      try {
        setConnectionStatus('Connecting ...');

        if (isConnected()) return true; // Already connected

        const result = await connectPrinter(
          ipAddress,
          setConnectionStatus,
          setIsVisible
        );

        if (result) {
          setConnectionStatus(STATUS_CONNECTED);

          return true;
        } else {
          return false;
        }
      } catch (err) {
        console.error('Failed to connect to printer:', err);
        alert('Error connecting to printer: ' + err.message);

        return false;
      } finally {
        setIsVisible(false);
      }
    },
    [isConnected]
  );

  return {
    connect,
    disconnect: disconnectPrinter,
    isConnected,
  };
};
